import { createFileRoute, redirect } from "@tanstack/react-router";
import { InvoicesClient } from "@/features/billing/InvoicesClient";
import { firstAllowedRoute, hasModule } from "@/lib/auth";
import { toDateInput } from "@/lib/dates";

// Commercie → Facturen (docs/tms-facturatie.md §18): reading is billing; making the proposals, holding, making
// final and crediting billing_write.
export const Route = createFileRoute("/_shell/billing/invoices")({
  beforeLoad: ({ context }) => {
    const { session } = context;
    if (!session.roles.includes("admin") && !hasModule(session, "billing") && !hasModule(session, "billing_write")) {
      throw redirect({ to: firstAllowedRoute(session) });
    }
  },
  component: InvoicesScreen,
});

function InvoicesScreen() {
  const { session } = Route.useRouteContext();
  const canWrite = session.roles.includes("admin") || hasModule(session, "billing_write");
  return (
    <div className="wl-page" data-screen-label="Back-office Facturen">
      <InvoicesClient canWrite={canWrite} today={toDateInput(new Date())} />
    </div>
  );
}
